ScrollTrigger.batch('.gsap-scroll', {
	onEnter: (elements) => {
		gsap.from(elements, {
			autoAlpha: 0,
			y: 100,
			stagger: 0.3,
		});
	},
	once: true,
});

var tl = gsap.timeline({
	scrollTrigger: {
		trigger: '.gsap-scroll-img',
		scrub: true,
		start: 'top bottom-=50px',
		end: 'top top+=100px',
	},
});
tl.from('.gsap-scroll-img', {
	y: 200,
	autoAlpha: 0,
	ease: 'power2',
});

// Parallax 1
var pl = gsap.timeline({
    scrollTrigger: {
        trigger: '.mm-tis-left-1',
        scrub: true,
        start: 'top bottom-=20%',
        end: 'bottom bottom-=20%',
        toggleClass: { targets: ".mm-tias-block-1", className: "active" },
        zIndex: 0
    },
});
// Current bloc + Img
pl.from('.mm-wrap-1', {
	y: 50,
	autoAlpha: 0,
    ease: 'power2',
});

if (window.innerWidth < 1040) {
    // Parallax 2
    var pl = gsap.timeline({
        scrollTrigger: {
            trigger: '.mm-tis-left-2',
            scrub: true,
            start: 'top bottom-=20%',
            end: 'bottom bottom-=20%',
            toggleClass: { targets: ".mm-tias-block-2", className: "active" },
            zIndex: 0
        },
    });
    // Prev bloc
    pl.to('.mm-tis-left-1', {
        y: -150,
        autoAlpha: 0,
        ease: 'power2',
    });
    // Current bloc
    pl.from('.mm-tis-left-2', {
        y: 150,
        autoAlpha: 0,
        ease: 'power2',
    }, -.1);
    // Img
    pl.from('.mm-tis-right-2', {
        opacity: 0,
        autoAlpha: 0,
        ease: 'power2'
    });

    // Parallax 3
    var pl = gsap.timeline({
        scrollTrigger: {
            trigger: '.mm-tis-left-3',
            scrub: true,
            start: 'top bottom-=10%',
            end: 'top bottom-=20%',
            toggleClass: { targets: ".mm-tias-block-3", className: "active" },
            zIndex: 0
        },
    });
    // Prev bloc
    pl.to('.mm-tis-left-2', {
        y: -150,
        autoAlpha: 0,
        ease: 'power2'
    });
    // Current bloc
    pl.from('.mm-tis-left-3', {
        y: 150,
        autoAlpha: 0,
        ease: 'power2',
    }, -.1);
    // Img
    pl.from('.mm-tis-right-3', {
        opacity: 0,
        autoAlpha: 0,
        ease: 'power2'
    });
} else {
    // Parallax 2
    var pl = gsap.timeline({
        scrollTrigger: {
            trigger: '.mm-tis-left-2',
            scrub: true,
            start: 'top bottom-=20%',
            end: 'bottom bottom-=20%',
            toggleClass: { targets: ".mm-tias-block-2", className: "active" },
            zIndex: 0
        },
    });
    // Prev bloc
    pl.to('.mm-tis-left-1', {
        y: -150,
        autoAlpha: 0,
        ease: 'power2',
    });
    // Current bloc
    pl.from('.mm-tis-left-2', {
        y: 150,
        autoAlpha: 0,
        ease: 'power2',
    }, -.1);
    // Img
    pl.from('.mm-tis-right-2', {
        opacity: 0,
        autoAlpha: 0,
        ease: 'power2'
    });
    // Parallax 3
    var pl = gsap.timeline({
        scrollTrigger: {
            trigger: '.mm-tis-left-3',
            scrub: true,
            start: 'top bottom-=30%',
            end: 'top center-=15%',
            toggleClass: { targets: ".mm-tias-block-3", className: "active" },
            zIndex: 0
        },
    });
    // Prev bloc
    pl.to('.mm-tis-left-2', {
        y: -150,
        autoAlpha: 0,
        ease: 'power2'
    });
    // Current bloc
    pl.from('.mm-tis-left-3', {
        y: 50,
        autoAlpha: 0,
        ease: 'power2',
    }, -.1);
    // Img
    pl.from('.mm-tis-right-3', {
        opacity: 0,
        autoAlpha: 0,
        ease: 'power2'
    });
}

var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

initGorgiasChatPromise.then(async () => {
  GorgiasChat.hidePoweredBy(true)
})